

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { SAVE_WORK_RELATION_TIMESHEET_COMMENT } from '@/queries/Timesheet';

@Component
export default class TimesheetComment extends Vue {
  @Prop() public comment!: string;
  @Prop() public selectedWorkRelationId!: string;
  private savingComment = false;
  private copiedComment = '';

  private created() {
    this.copiedComment = this.comment || '';
  }

  @Watch('comment')
  private commentChanged() {
    this.copiedComment = this.comment || '';
  }

  private async saveComment() {
    this.savingComment = true;
    try {
      await this.$apollo.mutate({
        mutation: SAVE_WORK_RELATION_TIMESHEET_COMMENT,
        variables: {
          workRelationId: this.selectedWorkRelationId,
          timesheetComment: this.copiedComment,
        },
      });
      this.$sMessage.success(this.$t('Timesheet.savingCommentSuccess'));
      this.$emit('saved', this.copiedComment);
    } finally {
      this.savingComment = false;
    }
  }
}
